import {BRAND} from './brand';
import {CHROME} from './chrome';

export const statamicTokens = {
    chrome: CHROME,

    color: {
        page: '#F5F5F5',
        surface: '#FFFFFF',
        sidebar: CHROME.sidebarBg,
        sidebarHover: CHROME.sidebarItemHover,
        sidebarActive: CHROME.sidebarItemActive,

        text: {
            primary: '#111827',
            secondary: '#6B7280',
            muted: '#9CA3AF',
            inverse: '#FFFFFF',
        },

        border: {
            default: '#E5E7EB',
            strong: '#D1D5DB',
            hairline: '#F3F4F6',
        },

        accent: {
            primary:       BRAND.main,
            primaryHover:  BRAND.hover,
            primaryActive: BRAND.active,
            primaryTint:   BRAND.tint,
            onPrimary:     BRAND.on,
        },

        status: {
            successSolid: '#10B981',
            successTint: '#ECFDF5',
            warningSolid: '#F59E0B',
            warningTint: '#FFFBEB',
            dangerSolid: '#EF4444',
            dangerTint: '#FEF2F2',
            infoSolid: BRAND.main,
            infoTint:  BRAND.tint,
            neutralSolid: '#9CA3AF',
            neutralTint: '#F3F4F6',
        },

        chip: {
            bg: '#F3F4F6',
            text: '#374151',
            monoBg: '#F9FAFB',
            monoText: '#4B5563',
        },
    },

    space: {
        0: 0,
        1: 4,
        2: 8,
        3: 12,
        4: 16,
        5: 20,
        6: 24,
        8: 32,
        10: 40,
        12: 48,
        16: 64,
    },

    radius: {
        sm: 4,
        md: 6,
        lg: 8,
        pill: 9999,
    },

    shadow: {
        none: 'none',
        panel: '0 1px 2px rgba(16, 24, 40, 0.04)',
        dropdown: '0 4px 12px rgba(16, 24, 40, 0.08)',
        modal: '0 12px 32px rgba(16, 24, 40, 0.12)',
    },

    font: {
        sans: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        mono: '"JetBrains Mono", "SF Mono", Consolas, "Liberation Mono", monospace',
    },

    type: {
        display: { size: 24, weight: 700, lineHeight: 1.25, tracking: '-0.01em' },
        h2:      { size: 18, weight: 600, lineHeight: 1.35, tracking: '-0.005em' },
        h3:      { size: 15, weight: 600, lineHeight: 1.4 },
        body:    { size: 14, weight: 400, lineHeight: 1.5 },
        bodyStrong: { size: 14, weight: 600, lineHeight: 1.5 },
        small:   { size: 13, weight: 400, lineHeight: 1.45 },
        caption: { size: 12, weight: 400, lineHeight: 1.4 },
        mono:    { size: 12, weight: 500, lineHeight: 1.4 },
    },

    dot: {
        size: 8,
        gap: 8,
    },

    table: {
        rowHeight: 52,
        headerHeight: 40,
        cellPaddingX: 16,
    },
};

export const t = statamicTokens;
